import React, { Component } from 'react';

export class SummaryItem extends Component {

  getIconClass = () => {
    return "fa fa-1x " + this.props.iconClass;
  }

  render () {
      return (
        <div className="widget widget-summary navy-bg  text-center summary-item">
            <div>
                <h5 className="no-margins">
                    {this.props.title} <i className={this.getIconClass()}></i>
                </h5>

                <h5 className="m-xs summary-value">{this.props.value}</h5>
            </div>
        </div>
      )}
}



// WEBPACK FOOTER //
// ./src/components/SummaryItem.js